import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const ProvinceContext = React.createContext(null);

const { Provider } = ProvinceContext;

export const ProvinceProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        province: null,

        regioni: null,
        regioniOptions: [],
    });

    const {
        province,
    } = state;

    const [isLoadingRegioni, setIsLoadingRegioni] = useState(false);
    const getRegioniAsync = async (term = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingRegioni(true);
            const r = await fetchAuthorized(ApiRoutes.Regione.GetRegioni({ term, pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({
                regioni: list, regioniOptions: list.result.map(e => {
                    return { regioneId: e.id, label: `${e.descrizione}` }
                }).sort((a, b) => a.label.localeCompare(b.label))
            });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingRegioni(false);
        }
    }

    const [isLoadingProvince, setIsLoadingProvince] = useState(false);
    const getProvinceAsync = async (pageIndex = 0, pageSize = 100, term = null, valid = false, regioneId = null) => {
        try {
            setIsLoadingProvince(true);
            valid = valid ? true : null;
            const r = await fetchAuthorized(ApiRoutes.Provincia.GetProvince({
                pageIndex,
                pageSize,
                term,
                valid,
                regioneId
            }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result.forEach(x => {
                x.inizioValidita = new Date(x.inizioValidita);
                x.fineValidita = x.fineValidita ? new Date(x.fineValidita) : null;
                if (x.regione) {
                    x.regione.inizioValidita = new Date(x.regione.inizioValidita);
                    x.regione.fineValidita = x.regione.fineValidita ? new Date(x.regione.fineValidita) : null;
                }
            })
            setState({ province: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingProvince(false);
        }
    }

    const [isDeletingProvincia, setIsDeletingProvincia] = useState(false);
    const deleteProvinciaAsync = async (provinciaId,) => {
        try {
            setIsDeletingProvincia(true);
            if (window.confirm("Confermare l'eliminazione?")) {
                const r = await fetchAuthorized(ApiRoutes.Provincia.DeleteProvincia({ provinciaId }), {
                    method: HttpMethods.DELETE
                });
                const list = province.result;
                list.forEach(x => {
                    if (x.id == provinciaId)
                        x.fineValidita = new Date();
                });
                setState({
                    province: {
                        ...province, result: list
                    }
                });
                showSuccessMessage(`Provincia con id ${provinciaId} eliminato`);
            }
        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingProvincia(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingRegioni,
            getRegioniAsync,

            isLoadingProvince,
            getProvinceAsync,

            isDeletingProvincia,
            deleteProvinciaAsync,
        }}>
            {props.children}
        </Provider>
    );
}